module.exports = __webpack_public_path__ + "img/market.e57fb06f.svg";